/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('global/EventBuilder',['./Logger'], function (Logger) {
    'use strict';
    
    /**
     * 
     * @param eventArray - an array of event names
     * @param {String} eventNamespace - event namespace
     * @returns {String} event name
     */
    function buildName(eventArray, eventNamespace) {
        if (!eventArray || !eventArray.length || !eventNamespace) {
            return;
        }

        if (eventNamespace.charAt(0) !== '.') {
            eventNamespace = '.' + eventNamespace;
        }

        var namespacedEventArray = [];

        for (var i = 0; i < eventArray.length; i++) {
            namespacedEventArray.push(eventArray[i] + eventNamespace);
        }

        return namespacedEventArray.join(' ');
    };

    var EventBuilder = {
        buildName : buildName
    };

    Logger.debug('EventBuilder.js Loaded:', EventBuilder);

    return EventBuilder;
});

